import { useState, useCallback, useRef } from 'react'
import Box from '@mui/material/Box'
import ShareCodeInput from './ShareCodeInput'
import ImageUploader from './ImageUploader'
import api from 'services/api'
import LoadingButton from '@mui/lab/LoadingButton'
import useToast from 'hooks/useToast'
import Heading from './Heading'

const ChangeRealpic = () => {
  const toast = useToast()
  const [shareLink, setShareLink] = useState('')
  const [file, setFile] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const imageRef = useRef(null)

  const updateCoverPhoto = useCallback(async () => {
    if (!file || !shareLink) return

    const shareCode = shareLink.split('/').slice(-1)[0]
    const formData = new FormData()
    formData.append('file', file)

    try {
      setIsLoading(true)
      await api.reclips.uploadCoverPhotoByShareCode({
        shareCode: shareCode,
        formData,
      })
      toast({ message: 'realPic updated' })
      setShareLink('')
      setFile(null)
      imageRef.current.clear()
    } catch (e) {
      toast({ message: e.message, severity: 'error' })
    } finally {
      setIsLoading(false)
    }
  }, [shareLink, file, toast])

  return (
    <Box>
      <Heading text="1. Enter share link" />
      <ShareCodeInput shareLink={shareLink} onChange={setShareLink} />
      <Heading text="2. Choose an image from your hard drive" />
      <ImageUploader ref={imageRef} setFile={setFile} disabled={!shareLink} />
      <Heading text="3. Change the realPic" />
      <LoadingButton
        variant="contained"
        disabled={!shareLink || !file}
        onClick={updateCoverPhoto}
        loading={isLoading}
      >
        Change Pic
      </LoadingButton>
    </Box>
  )
}

export default ChangeRealpic
